// import React, { useEffect, useState } from "react";
// import {
//   Input,
//   Button,
//   Form,
//   Card,
//   message,
//   DatePicker,
//   Select,
//   Radio,
//   Col,
//   Row,
// } from "antd";
// import moment from "moment";
// import Service from "../../../service";
// import { Option } from "antd/lib/mentions";
// import { Link } from "react-router-dom";

// import { showAuthLoader, hideAuthLoader } from "../../../appRedux/actions/Auth";
// import { useDispatch, useSelector } from "react-redux";
// const { TextArea } = Input;

// const columns = [
//   {
//     title: "Leave",
//     dataIndex: "leave",
//     key: "leave",
//   },
//   {
//     title: "Balance",
//     dataIndex: "balance",
//     key: "balance",
//   },
// ];

// const AddWfhRequest = (props) => {
//   const [form] = Form.useForm();
//   const [formItems, setFormItems] = useState(false);

//   const [dates, setDates] = useState("");
//   const [employeeData, setEmployeeData] = useState({})

//   const [leaveBalance, setLeaveBalance] = useState([]);
//   const [days, setDays] = useState("");
//   const [isAddLeaveEnabled, setIsLeaveEnabled] = useState(true);
//   const [isAddCompffEnabled, setIsCompffEnabled] = useState(true);
//   const [numOfHours, setNumOfHours] = useState("");

//   const [reportingManager, setReportingManager] = useState("");
//   const [floatflag, setFloatflag] = useState(false);
//   const pattern = /(^[0-9]\.5$)|(^[0-9][0-9]*(\.[05])?$)/;
//   const dispatch = useDispatch();
//   const [alldate, setAlldate] = useState([]);
//   const [wfh_type, setwfh_type] = useState([]);


//   let { authUser } = useSelector(({ auth }) => auth);

//   let sendData;
//   let WFHDataArray;

//   const dataSource = [
//     {
//       key: "1",
//       leave: "Comp-Off Leave",
//       balance: `${leaveBalance[0]?.compoff_leave
//         ? leaveBalance[0]?.compoff_leave + " days"
//         : "0"
//         }`,
//     },
//     {
//       key: "2",
//       leave: "Flexi Leave",
//       balance: `${leaveBalance[0]?.flexy_leave
//         ? leaveBalance[0]?.flexy_leave + " Hours"
//         : "0"
//         }`,
//     },
//     {
//       key: "3",
//       leave: "Leave",
//       balance: `${leaveBalance[0]?.paid_leave
//         ? leaveBalance[0]?.paid_leave + " days"
//         : "0"
//         }`,
//     },
//     {
//       key: "4",
//       leave: "LWP",
//       balance: `${leaveBalance[0]?.unpaid_leave
//         ? leaveBalance[0]?.unpaid_leave + " days"
//         : "0"
//         }`,
//     },
//     {
//       key: "5",
//       leave: "Birthday Leave",
//       balance: `${leaveBalance[0]?.birthday_leave
//         ? leaveBalance[0]?.birthday_leave + " days"
//         : "0"
//         }`,
//     },
//   ];
//   // function disabledDate(current) {
//   //   const today = moment();
//   //   const startOfMonth = moment().startOf("month");

//   //   if (moment(current).day() === 0 || moment(current).day() === 6) {
//   //     return true;
//   //   }

//   //   if (!isAddLeaveEnabled) {
//   //     if (moment(current).isBefore(startOfMonth, "day")) {
//   //       return true;
//   //     }
//   //     if (moment(current).isSameOrBefore(startOfMonth, "month")) {
//   //       return true;
//   //     }
//   //   }
//   //   return false;
//   // }

//   const fetchAppSettings = async () => {
//     const response = await Service.makeAPICall({
//       methodName: Service.getMethod,
//       api_url: Service.getAppSettings,
//     });

//     const data = response?.data?.data;
//     data?.map((e) => {
//       if (e?.slug === "add-leave") {
//         setIsLeaveEnabled(e?.is_enable);
//       }
//       if (e?.slug === "add-comp-off") {
//         setIsCompffEnabled(e?.is_enable);
//       }
//     });
//   };

//   useEffect(() => {
//     getEmpLeaveBalance();
//     fetchAppSettings();
//     getreportingmanager();
//   }, []);

//   // const calculateToDate = () => {
//   //   if (formItems === false && dates && days) {
//   //     var startDate = moment(dates?._d);

//   //     let endDate;

//   //     let count = 0;
//   //     while (count < days) {
//   //       endDate = moment(startDate.set("date", startDate.get("date")));
//   //       // if (endDate.isoWeekday() == 6 || endDate.isoWeekday() == 7) {
//   //       //   endDate = moment(
//   //       //     startDate.set("date", startDate.get("date")).add(1, "days")
//   //       //   );
//   //       // } else {
//   //       count++;
//   //       endDate = moment(
//   //         startDate.set("date", startDate.get("date")).add(1, "days")
//   //       );
//   //       // }
//   //     }

//   //     let finalEndDate = moment(endDate).add(-1, "days");
//   //     sendData = finalEndDate;
//   //     leaveDataArray = getDatesWithoutWeekends(dates, finalEndDate);

//   //     return finalEndDate;
//   //   } else {
//   //     return dates;
//   //   }
//   // };
//   const getDates = (startDate, endDate) => {
//     let datesArray = [];

//     // Parse start and end dates using moment
//     var currentDate = moment(startDate, "DD-MM-YYYY");
//     const stopDate = moment(endDate, "DD-MM-YYYY");

//     // Push each date to the array until the end date is reached
//     while (currentDate <= stopDate) {
//       datesArray.push({
//         particular_date: moment(new Date(currentDate)).format("MM-DD-YYYY"),
//         wfh_type: form.getFieldValue("wfh_type"),
//       });
//       currentDate.add(1, 'days'); // Increment by 1 day
//     }
//     return datesArray;
//   };

//   let leaveDays = [];
//   const calculateToDate = () => {
//     if (formItems === false && dates && days) {
//       let startDate = moment(dates?._d);  // Starting from the selected start date
//       let count = 0;
//       const totalDays = Math.floor(days);  // Total whole days
//       const isHalfDay = days % 1 !== 0;    // Check if it's a half-day
//       const includeWeekoff = form.getFieldValue("is_weekoff") === "true"; // Check if weekends are included


//       // Initialize leaveDays array for storing the leave days


//       // Loop through days, accounting for weekends if "includeWeekoff" is true
//       while (count < totalDays) {
//         // Always increment the day, but only count it if it's valid
//         if (includeWeekoff || (startDate.isoWeekday() !== 6 && startDate.isoWeekday() !== 7)) {
//           leaveDays.push(moment(startDate).format("DD-MM-YYYY"));  // Add the day to the leaveDays array
//           count++;  // Increment count only for valid days
//         }
//         startDate.add(1, "days");  // Move to the next day
//       }

//       // Handle half-day logic
//       if (isHalfDay) {
//         // leaveDays.push(moment(startDate).format("DD-MM-YYYY"));  // Add the final half-day
//         while (!includeWeekoff && (startDate.isoWeekday() === 6 || startDate.isoWeekday() === 7)) {
//           startDate.add(1, "days");
//         }
//         // Add the final half-day
//         leaveDays.push(moment(startDate).format("DD-MM-YYYY"));
//       }

//       // Set the correct end date based on the number of days
//       console.log("🚀 ~ calculateToDate ~ startDate:", days)
//       const finalEndDate = days == "0.5" ? startDate : floatflag && pattern.test(days) ? moment(startDate) : moment(startDate).add(-1, "days");  // Set the correct end date (subtract 1 day)


//       // Update leaveDataArray with the calculated dates
//       WFHDataArray = includeWeekoff
//         ? getDates(dates, finalEndDate)  // Get all dates, including weekends
//         : getDatesWithoutWeekends(dates, finalEndDate);  // Get only weekdays if weekends are excluded

//       // Debugging log: Check the leaveDataArray
//       console.log("Updated Leave Data Array:", WFHDataArray);
//       sendData = finalEndDate
//       return finalEndDate;  // Return the final calculated end date
//     } else {
//       console.log("Missing necessary form values or invalid input.");
//       return dates;  // Fallback if formItems, dates, or days are not set
//     }
//   };

//   function getDatesWithoutWeekends(startDate, endDate) {
//     var dates = [];
//     var currentDate = new Date(startDate);
//     while (currentDate <= endDate) {
//       if (currentDate.getDay() !== 0 && currentDate.getDay() !== 6) {
//         dates.push({
//           particular_date: moment(new Date(currentDate)).format("MM-DD-YYYY"),
//           wfh_type: form.getFieldValue("wfh_type"),
//         });
//       }
//       currentDate.setDate(currentDate.getDate() + 1);
//     }
//     return dates;
//   }

//   const getEmpLeaveBalance = async () => {
//     const reqBody = { emp_code: authUser?.emp_code };
//     const response = await Service.makeAPICall({
//       methodName: Service.postMethod,
//       api_url: Service.empLeaveBalance,
//       body: reqBody,
//     });

//     if (response.data && response.data.data) {
//       setLeaveBalance(response.data.data);
//     } else {
//       console.log("error");
//     }
//   };

//   const id = authUser?._id;

//   const getreportingmanager = async () => {
//     const params = `/${id}`;
//     const response = await Service.makeAPICall({
//       methodName: Service.getMethod,
//       api_url: Service.reportingmanager + params,
//     });

//     if (response?.data && response?.data?.data) {
//       setReportingManager(response?.data?.data);
//     } else {
//       console.log("error");
//     }
//   };

//   const handleSubmit = async (values, e) => {
//     try {
//       console.log("🚀 ~ handleSubmit ~ sendData:", alldate, "---------", WFHDataArray)

//       delete values.days;
//       console.log(alldate, "alldatealldate")
//       const reqBody = {
//         ...values,
//         custompartday: moment(values?.custompartday).format("MM-DD-YYYY"),
//         employee_id: authUser?._id,
//         from_date: moment(values?.from_date).format("MM-DD-YYYY"),
//         reporting_manager: authUser?.reporting_manager,
//         application_date: moment().format("MM-DD-YYYY"),
//         to_date: sendData
//           ? moment(sendData).format("MM-DD-YYYY")
//           : moment(dates).format("MM-DD-YYYY"),
//         is_weekoff: values.is_weekoff == "true" ? true : false,
//         wfh_dates:
//           alldate.length > 0
//             ? alldate.map((item) => (console.log(item.particular_date, "item.particular_date"), {
//               ...item,
//               wfh_type: item.wfh_type == undefined || item.wfh_type == "" ? values.wfh_type : item.wfh_type,
//               particular_date: moment(item.particular_date).format("MM-DD-YYYY"), // Change format here
//             }))
//             : WFHDataArray
//               ? WFHDataArray.map((item) => (console.log(item.particular_date, "item.particular_date"), {
//                 ...item,
//                 wfh_type: values.wfh_type ? values.wfh_type : "Full Day",
//                 particular_date: moment(item.particular_date).format("MM-DD-YYYY"), // Change format here
//               }))
//               : [
//                 {
//                   particular_date: moment(dates,).format("MM-DD-YYYY"), // Ensure fallback uses "DD-MM-YYYY"
//                   wfh_type: wfh_type ? wfh_type : "Part Day",
//                 },
//               ]

//       };

//       dispatch(showAuthLoader());
//       const response = await Service.makeAPICall({
//         methodName: Service.postMethod,
//         api_url: Service.addwfh,
//         body: reqBody,
//       });
//       dispatch(hideAuthLoader());
//       if (response.data && response.data.data) {
//         props.history.push("/work-from-home-application");
//         message.success(response.data.message);
//       } else {
//         message.error(response.data.message);
//       }
//     } catch (error) {
//       dispatch(hideAuthLoader());

//       console.log(error);
//     }
//   };

//   const onDateChange = (val) => {
//     form.setFieldsValue({
//       custompartday: "",
//     });
//     setDates(val);
//   };
//   function disabledDate(current) {
//     const today = moment().startOf('day'); // Get the start of the current day

//     // Disable dates that are before today
//     return current && current < today;
//   }
//   function isEndOfMonth(date) {
//     let momentDate = moment(date);
//     let endOfMonth = momentDate.clone().endOf("month");
//     let lastdate =
//       moment(endOfMonth).day() == 0
//         ? moment(endOfMonth).subtract(2, "days")
//         : moment(endOfMonth).day() == 6
//           ? moment(endOfMonth).subtract(1, "days")
//           : moment(endOfMonth);
//     return momentDate.date() === lastdate.date();
//   }

//   const checkfloat = (num) => {
//     let realnum = num * 1;
//     realnum > 1 && realnum % 1 != 0 ? setFloatflag(true) : setFloatflag(false);
//   };
//   const isendmonth = isEndOfMonth(dates);
//   console.log(isendmonth, "isendmonth");
//   const fetchEmployeeDetails = async () => {
//     try {
//       dispatch(showAuthLoader());
//       const response = await Service.makeAPICall({
//         methodName: Service.getMethod,
//         api_url: Service.empById + `/${authUser._id}`
//       });
//       if (response?.data && response.data.status === 200) {
//         const empData = response?.data?.data
//         // console.log(empData,'empData');

//         setEmployeeData(empData)
//       } else {
//         message.error(response.data.message)
//       }
//       dispatch(hideAuthLoader());
//     } catch (error) {
//       dispatch(hideAuthLoader());
//       console.log(error);
//     }
//   };

//   useEffect(() => {
//     fetchEmployeeDetails()
//   }, [])
//   return (
//     <>

//       <Card className="employee-card">

//         <div className="inout-header text-left">
//           <div className="title">
//             <h2>Add WFH Application  </h2>
//           </div>
//           <div className="leave-application-back-btn">

//             <Link to="/work-from-home-application">
//               { " " }
//               <Button
//                 type="primary"
//                 className="addleave-btn"
//               // style={{ float: "right" }}
//               >
//                 Back
//               </Button>
//             </Link>
//           </div>
//         </div>

//         <Form
//           form={ form }
//           noValidate={ true }
//           // {...formItemLayout}
//           onFinish={ handleSubmit }
//         >
//           <div className="main-form-wrapper">
//             <div className="left-form-wrapper">
//             <div className="form-item">
//               <Form.Item
//                 className="search-row"
//                 label="Application Date"
//                 name="application_date"
//               >
//                 <span>{ moment().format("DD-MMM-YYYY") }</span>
//               </Form.Item>
// </div>
//             <div className="form-item">

//               <Form.Item
//                 className="search-row"
//                 label="Reporting Manager"
//                 name="reporting_manager"
//               >
//                 <span>{ reportingManager?.reporting_manager?.full_name }</span>
//               </Form.Item>
// </div>
//             <div className="form-item">

//               <Form.Item
//                 label="From Date"
//                 name="from_date"
//                 className="search-row"
//                 rules={ [
//                   {
//                     required: true,
//                     message: "Please enter your Application Dates!",
//                   },
//                 ] }
//               >
//                 <DatePicker
//                   format={ "DD-MM-YYYY" }
//                   className="fulldate-width"
//                   onChange={ onDateChange }
//                   disabledDate={ disabledDate }
//                 />
//               </Form.Item>
// </div>
//             <div className="form-item">

//               <Form.Item
//                 className="radio_group leave-radio"
//                 label="Including Weekoff"
//                 name="is_weekoff"
//                 initialValue={ "false" }
//                 rules={ [
//                   {
//                     required: true,
//                     message: "Please select an option!",
//                   },
//                 ] }
//               >
//                 <Radio.Group
//                   name="radiogroup"
//                   className="start-enddate"
//                   onChange={ (e) => {
//                     // Set the value of the selected option and re-calculate the "To Date"
//                     form.setFieldsValue({ is_weekoff: e.target.value });
//                     // Recalculate and update the "To Date"
//                     setDays("");
//                     form.setFieldsValue({ no_of_days: "" });
//                     form.setFieldsValue({ wfh_type: "" });

//                     form.setFieldsValue({ custompartday: "" });

//                     form.setFieldsValue({
//                       to_date: moment(calculateToDate()).format("DD-MM-YYYY"),
//                     });
//                   } }
//                 >
//                   <Radio value="true">Yes</Radio>
//                   <Radio value="false">No</Radio>
//                 </Radio.Group>
//               </Form.Item>
// </div>
//             <div className="form-item">

//               <Form.Item
//                 label={ <>No. of Days</> }
//                 name="no_of_days"
//                 className="search-row"
//                 rules={ [
//                   {
//                     required: true,
//                     message: "Please enter the number of Days!",
//                   },
//                   {
//                     validator: (_, value) => {
//                       // Allow empty value since it's handled by "required" rule
//                       if (!value) return Promise.resolve();

//                       // Parse the value to float
//                       const floatValue = parseFloat(value);

//                       // Check for 0 value
//                       if (floatValue === 0) {
//                         return Promise.reject("Min WFH can be taken is 0.5");
//                       }

//                       // Regular expression to allow only multiples of 0.5
//                       const validPattern = /^(0.5|[1-9][0-9]*(\.5)?)$/;
//                       if (!validPattern.test(value)) {
//                         return Promise.reject("Only multiples of 0.5 are allowed (e.g., 0.5, 1, 1.5, 2).");
//                       }

//                       return Promise.resolve();
//                     },
//                   },
//                 ] }
//               >
//                 <Input
//                   className="fulldate-width"
//                   type="number"
//                   onBlur={ (e) => {

//                     if (e.target.value == 0) {
//                       message.error("Min WFH can be taken is 0.5");
//                       setDays("");
//                       setAlldate([]);

//                       form.setFieldsValue({ no_of_days: "" });
//                     }
//                   } }

//                   controls={ false }

//                   onChange={ (e) => {
//                     checkfloat(e.target.value);
//                     setAlldate([])
//                     setDays(e.target.value);
//                     // Recalculate and update the "To Date" when days change
//                     form.setFieldsValue({
//                       to_date: moment(calculateToDate()).format("DD-MM-YYYY"),
//                     });
//                   } }
//                 />
//               </Form.Item>
//               </div>
//             <div className="form-item">


//               <Form.Item label="To Date" name="to_date" className="search-row">
//                 <span>

//                   { (days && dates) || (dates && numOfHours)
//                     ? moment(calculateToDate()).format("DD-MM-YYYY")
//                     : "" }
//                 </span>
//               </Form.Item>
// </div>



//               { floatflag && pattern.test(days) && (
//                 <>

//             <div className="form-item">

//                   <Form.Item
//                     name="custompartday"
//                     className="search-row"
//                     label="Date For Half Day"
//                     rules={ [
//                       {
//                         required: true,
//                         message: "Please Select the date for your half day leave!",
//                       },
//                     ] }
//                   >
//                     <Select
//                       onChange={ (e) => {
//                         let finalLeaveDatesArray = WFHDataArray.map((val) => {
//                           return val.particular_date !== e
//                             ? { ...val, wfh_type: "Full Day" }
//                             : { ...val, wfh_type: form.getFieldValue("wfh_type") };
//                         });
//                         setAlldate(finalLeaveDatesArray);
//                       } }
//                       placeholder="Select a date"
//                     >


//                       { WFHDataArray?.map((item, index) => (
//                         <Option key={ index } value={ item.particular_date }>
//                           { moment(item.particular_date).format("DD-MM-YYYY") }
//                         </Option>
//                       )) }
//                     </Select>
//                   </Form.Item>
// </div>
//             <div className="form-item">

//                   <Form.Item
//                     className="search-row"
//                     label="WFH type"
//                     name="wfh_type"
//                     rules={ [
//                       {
//                         required: true,
//                         message: "Please enter WFH type!",
//                       },
//                     ] }
//                   >
//                     <Select
//                       onChange={ (e) => {
//                         setwfh_type(e);


//                       } }
//                       options={ [
//                         {
//                           value: "First Half",
//                           label: "First Half",
//                           // disabled:
//                           //   !noofdayfloatflag && leaveType != "birthday_leave",
//                         },
//                         {
//                           value: "Second Half",
//                           label: "Second Half",
//                           // disabled:
//                           //   !noofdayfloatflag && leaveType != "birthday_leave",
//                         },
//                       ] }
//                     />
//                   </Form.Item>
// </div>



//                 </>
//               ) }


//               { days == "0.5" && (
//                 <div className="form-item">
//                 <Form.Item
//                   className="search-row"
//                   label="WFH type"
//                   name="wfh_type"
//                   rules={ [
//                     {
//                       required: true,
//                       message: "Please enter WFH type!",
//                     },
//                   ] }
//                 >
//                   <Select
//                     onChange={ (e) => {
//                       setwfh_type(e);


//                     } }
//                     options={ [
//                       {
//                         value: "First Half",
//                         label: "First Half",
//                         // disabled:
//                         //   !noofdayfloatflag && leaveType != "birthday_leave",
//                       },
//                       {
//                         value: "Second Half",
//                         label: "Second Half",
//                         // disabled:
//                         //   !noofdayfloatflag && leaveType != "birthday_leave",
//                       },
//                     ] }
//                   />
//                 </Form.Item>
//                 </div>
//               ) }
//             <div className="form-item">

//               <Form.Item
//                 className="search-row"
//                 label="Reason"
//                 name="reason"
//                 rules={ [
//                   {
//                     required: true,
//                     message: "Please enter your reason !",
//                   },
//                 ] }
//               >
//                 <TextArea maxLength={ 100 } style={ { height: 50 } } />
//               </Form.Item>
// </div>
//             <div className="form-item">

//               <Form.Item className="ant-col-xs-24 ant-col-sm-24 leavebtns">
//                 <div className="add-leave-button">
//                   <Button id="addbutton" type="primary" htmlType="submit"
//                     disabled={ employeeData.emp_type == "Probation" ||
//                       (employeeData.left_date !== null && employeeData.emp_last_working_date !== null) }
//                   >
//                     Submit
//                   </Button>
//                   <Button
//                     type="primary"
//                     className="delete-btn"
//                     onClick={ () => {
//                       form.resetFields();
//                       setDays("");
//                     } }
//                   >
//                     Clear
//                   </Button>
//                 </div>
//               </Form.Item>

//               {/* <Col md={12} sm={24}>
//               <div className="leave-balance">
//                 <div className="inout-header">
//                   <h4>Leave Balance</h4>
//                 </div>
//                 <Table
//                   dataSource={dataSource}
//                   columns={columns}
//                   pagination={false}
//                 />
//               </div>
//             </Col> */}
//             </div>
//             </div>
//           </div>
//         </Form>
//       </Card>
//     </>
//   );
// };
// export default AddWfhRequest;



import React, { useEffect, useState } from "react";
import {
  Input,
  Button,
  Form,
  Modal,
  message,
  DatePicker,
  Select,
  Radio,
} from "antd";
import moment from "moment";
import Service from "../../../service";
import { Option } from "antd/lib/mentions";
import { showAuthLoader, hideAuthLoader } from "../../../appRedux/actions/Auth";
import { useDispatch, useSelector } from "react-redux";

const { TextArea } = Input;

const AddWfhRequestModal = ({ show, onClose, onSuccess }) => {
  const [form] = Form.useForm();
  const [dates, setDates] = useState("");
  const [employeeData, setEmployeeData] = useState({});
  const [days, setDays] = useState("");
  const [reportingManager, setReportingManager] = useState("");
  const [floatflag, setFloatflag] = useState(false);
  const [alldate, setAlldate] = useState([]);
  const [wfh_type, setwfh_type] = useState([]);

  const pattern = /(^[0-9]\.5$)|(^[0-9][0-9]*(\.[05])?$)/;
  const dispatch = useDispatch();
  const { authUser } = useSelector(({ auth }) => auth);

  let sendData;
  let WFHDataArray;

  const getDates = (startDate, endDate) => {
    let datesArray = [];
    var currentDate = moment(startDate, "DD-MM-YYYY");
    const stopDate = moment(endDate, "DD-MM-YYYY");

    while (currentDate <= stopDate) {
      datesArray.push({
        particular_date: moment(new Date(currentDate)).format("MM-DD-YYYY"),
        wfh_type: form.getFieldValue("wfh_type"),
      });
      currentDate.add(1, 'days');
    }
    return datesArray;
  };

  let leaveDays = [];
  const calculateToDate = () => {
    if (dates && days) {
      let startDate = moment(dates?._d);
      let count = 0;
      const totalDays = Math.floor(days);
      const isHalfDay = days % 1 !== 0;
      const includeWeekoff = form.getFieldValue("is_weekoff") === "true";

      while (count < totalDays) {
        if (includeWeekoff || (startDate.isoWeekday() !== 6 && startDate.isoWeekday() !== 7)) {
          leaveDays.push(moment(startDate).format("DD-MM-YYYY"));
          count++;
        }
        startDate.add(1, "days");
      }

      if (isHalfDay) {
        while (!includeWeekoff && (startDate.isoWeekday() === 6 || startDate.isoWeekday() === 7)) {
          startDate.add(1, "days");
        }
        leaveDays.push(moment(startDate).format("DD-MM-YYYY"));
      }

      const finalEndDate = days == "0.5" ? startDate : floatflag && pattern.test(days) ? moment(startDate) : moment(startDate).add(-1, "days");

      WFHDataArray = includeWeekoff
        ? getDates(dates, finalEndDate)
        : getDatesWithoutWeekends(dates, finalEndDate);

      sendData = finalEndDate;
      return finalEndDate;
    } else {
      return dates;
    }
  };

  function getDatesWithoutWeekends(startDate, endDate) {
    var dates = [];
    var currentDate = new Date(startDate);
    while (currentDate <= endDate) {
      if (currentDate.getDay() !== 0 && currentDate.getDay() !== 6) {
        dates.push({
          particular_date: moment(new Date(currentDate)).format("MM-DD-YYYY"),
          wfh_type: form.getFieldValue("wfh_type"),
        });
      }
      currentDate.setDate(currentDate.getDate() + 1);
    }
    return dates;
  }

  const getreportingmanager = async () => {
    const params = `/${authUser?._id}`;
    const response = await Service.makeAPICall({
      methodName: Service.getMethod,
      api_url: Service.reportingmanager + params,
    });

    if (response?.data && response?.data?.data) {
      setReportingManager(response?.data?.data);
    }
  };

  const fetchEmployeeDetails = async () => {
    try {
      dispatch(showAuthLoader());
      const response = await Service.makeAPICall({
        methodName: Service.getMethod,
        api_url: Service.empById + `/${authUser._id}`
      });
      if (response?.data && response.data.status === 200) {
        const empData = response?.data?.data;
        setEmployeeData(empData);
      } else {
        message.error(response.data.message);
      }
      dispatch(hideAuthLoader());
    } catch (error) {
      dispatch(hideAuthLoader());
      console.log(error);
    }
  };

  useEffect(() => {
    if (show) {
      getreportingmanager();
      fetchEmployeeDetails();
    }
  }, [show]);

  const handleSubmit = async (values) => {
    try {
      delete values.days;
      const reqBody = {
        ...values,
        custompartday: moment(values?.custompartday).format("MM-DD-YYYY"),
        employee_id: authUser?._id,
        from_date: moment(values?.from_date).format("MM-DD-YYYY"),
        reporting_manager: authUser?.reporting_manager,
        application_date: moment().format("MM-DD-YYYY"),
        to_date: sendData
          ? moment(sendData).format("MM-DD-YYYY")
          : moment(dates).format("MM-DD-YYYY"),
        is_weekoff: values.is_weekoff == "true" ? true : false,
        wfh_dates:
          alldate.length > 0
            ? alldate.map((item) => ({
              ...item,
              wfh_type: item.wfh_type == undefined || item.wfh_type == "" ? values.wfh_type : item.wfh_type,
              particular_date: moment(item.particular_date).format("MM-DD-YYYY"),
            }))
            : WFHDataArray
              ? WFHDataArray.map((item) => ({
                ...item,
                wfh_type: values.wfh_type ? values.wfh_type : "Full Day",
                particular_date: moment(item.particular_date).format("MM-DD-YYYY"),
              }))
              : [
                {
                  particular_date: moment(dates).format("MM-DD-YYYY"),
                  wfh_type: wfh_type ? wfh_type : "Part Day",
                },
              ]
      };

      dispatch(showAuthLoader());
      const response = await Service.makeAPICall({
        methodName: Service.postMethod,
        api_url: Service.addwfh,
        body: reqBody,
      });
      dispatch(hideAuthLoader());

      if (response.data && response.data.data) {
        message.success(response.data.message);
        handleClose();
        if (onSuccess) onSuccess();
      } else {
        message.error(response.data.message);
      }
    } catch (error) {
      dispatch(hideAuthLoader());
      console.log(error);
    }
  };

  const onDateChange = (val) => {
    form.setFieldsValue({
      custompartday: "",
    });
    setDates(val);
  };

  function disabledDate(current) {
    const today = moment().startOf('day');
    return current && current < today;
  }

  const checkfloat = (num) => {
    let realnum = num * 1;
    realnum > 1 && realnum % 1 != 0 ? setFloatflag(true) : setFloatflag(false);
  };

  const handleClose = () => {
    form.resetFields();
    setDates("");
    setDays("");
    setAlldate([]);
    setwfh_type([]);
    setFloatflag(false);
    onClose();
  };

  return (
    <Modal
      title="Add WFH Application"
      visible={ show }
      onCancel={ handleClose }
      width={ 800 }
      footer={ [
        <Button key="cancel" className="delete-btn" onClick={ handleClose }>
          Cancel
        </Button>,
        <Button
          key="clear"
          className="delete-btn"
          onClick={ () => {
            form.resetFields();
            setDates("");
            setDays("");
            setAlldate([]);
          } }
        >
        Reset
        </Button>,
        <Button
          key="submit"
          type="primary"
          htmlType="submit"
          onClick={ () => form.submit() }
          disabled={
            employeeData.emp_type == "Probation" ||
            (employeeData.left_date !== null && employeeData.emp_last_working_date !== null)
          }
        >
          Submit
        </Button>,
      ] }
      destroyOnClose
    >
      <Form form={ form } layout="vertical" onFinish={ handleSubmit }>
        <div className="main-form-wrapper">
          <div className="form-container">
            <div className="form-row">
              <div className="form-col">
                <div className="form-item">
                  <Form.Item label="Application Date" name="application_date">
                    <span>{ moment().format("DD-MMM-YYYY") }</span>
                  </Form.Item>
                </div>
              </div>
              <div className="form-col">
                <div className="form-item">
                  <Form.Item label="Reporting Manager" name="reporting_manager">
                    <span>{ reportingManager?.reporting_manager?.full_name }</span>
                  </Form.Item>
                </div>
              </div>
            </div>
            <div className="form-row">
              <div className="form-col">
                <div className="form-item">
                  <Form.Item
                    label="From Date"
                    name="from_date"
                    rules={ [{ required: true, message: "Please enter your Application Dates!" }] }
                  >
                    <DatePicker
                      format="DD-MM-YYYY"
                      className="fulldate-width"
                      onChange={ onDateChange }
                      disabledDate={ disabledDate }
                    />
                  </Form.Item>
                </div>
              </div>
              <div className="form-col">
                <div className="form-item">
                  <Form.Item
                    label="Including Weekoff"
                    name="is_weekoff"
                    initialValue="false"
                    rules={ [{ required: true, message: "Please select an option!" }] }
                  >
                    <Radio.Group
                      onChange={ (e) => {
                        form.setFieldsValue({ is_weekoff: e.target.value });
                        setDays("");
                        form.setFieldsValue({ no_of_days: "" });
                        form.setFieldsValue({ wfh_type: "" });
                        form.setFieldsValue({ custompartday: "" });
                        form.setFieldsValue({
                          to_date: moment(calculateToDate()).format("DD-MM-YYYY"),
                        });
                      } }
                    >
                      <Radio value="true">Yes</Radio>
                      <Radio value="false">No</Radio>
                    </Radio.Group>
                  </Form.Item>
                </div>
              </div>
            </div>
            <div className="form-row">
              <div className="form-col">
                <div className="form-item">
                  <Form.Item
                    label="No. of Days"
                    name="no_of_days"
                    rules={ [
                      { required: true, message: "Please enter the number of Days!" },
                      {
                        validator: (_, value) => {
                          if (!value) return Promise.resolve();
                          const floatValue = parseFloat(value);
                          if (floatValue === 0) {
                            return Promise.reject("Min WFH can be taken is 0.5");
                          }
                          if (floatValue > 2) {
                            return Promise.reject("Max WFH can be taken is 2");
                          }
                          const validPattern = /^(0.5|[1-9][0-9]*(\.5)?)$/;
                          if (!validPattern.test(value)) {
                            return Promise.reject("Only multiples of 0.5 are allowed (e.g., 0.5, 1, 1.5, 2).");
                          }
                          return Promise.resolve();
                        },
                      },
                    ] }
                  >
                    <Input
                      className="fulldate-width"
                      type="number"
                      min={0.5}
                      max={2}
                      step={0.5}
                      precision={1}
                      controls={ false }
                      onBlur={ (e) => {
                        if (e.target.value == 0) {
                          message.error("Min WFH can be taken is 0.5");
                          setDays("");
                          setAlldate([]);
                          form.setFieldsValue({ no_of_days: "" });
                        }
                      } }
                      onChange={ (e) => {
                        checkfloat(e.target.value);
                        setAlldate([]);
                        setDays(e.target.value);
                        form.setFieldsValue({
                          to_date: moment(calculateToDate()).format("DD-MM-YYYY"),
                        });
                      } }
                    />
                  </Form.Item>
                </div>
              </div>
              <div className="form-col">
                <div className="form-item">
                  <Form.Item label="To Date" name="to_date">
                    <span>
                      { (days && dates) ? moment(calculateToDate()).format("DD-MM-YYYY") : "" }
                    </span>
                  </Form.Item>
                </div>
              </div>
            </div>
            { floatflag && pattern.test(days) && (
              <div className="form-row">
                <div className="form-col">
                  <div className="form-item">
                    <Form.Item
                      name="custompartday"
                      label="Date For Half Day"
                      rules={ [{ required: true, message: "Please Select the date for your half day leave!" }] }
                    >
                      <Select
                        onChange={ (e) => {
                          let finalLeaveDatesArray = WFHDataArray.map((val) => {
                            return val.particular_date !== e
                              ? { ...val, wfh_type: "Full Day" }
                              : { ...val, wfh_type: form.getFieldValue("wfh_type") };
                          });
                          setAlldate(finalLeaveDatesArray);
                        } }
                        placeholder="Select a date"
                      >
                        { WFHDataArray?.map((item, index) => (
                          <Option key={ index } value={ item.particular_date }>
                            { moment(item.particular_date).format("DD-MM-YYYY") }
                          </Option>
                        )) }
                      </Select>
                    </Form.Item>
                  </div>
                </div>
                <div className="form-col">
                  <div className="form-item">
                    <Form.Item
                      label="WFH type"
                      name="wfh_type"
                      rules={ [{ required: true, message: "Please enter WFH type!" }] }
                    >
                      <Select
                        onChange={ (e) => {
                          setwfh_type(e);
                        } }
                        options={ [
                          { value: "First Half", label: "First Half" },
                          { value: "Second Half", label: "Second Half" },
                        ] }
                      />
                    </Form.Item>
                  </div>
                </div>
              </div>
            ) }
            { days == "0.5" && (
              <div className="form-row">
                <div className="form-col">
                  <div className="form-item">
                    <Form.Item
                      label="WFH type"
                      name="wfh_type"
                      rules={ [{ required: true, message: "Please enter WFH type!" }] }
                    >
                      <Select
                        onChange={ (e) => {
                          setwfh_type(e);
                        } }
                        options={ [
                          { value: "First Half", label: "First Half" },
                          { value: "Second Half", label: "Second Half" },
                        ] }
                      />
                    </Form.Item>
                  </div>
                </div>
                <div className="form-col">
                  {/* Empty column for spacing */ }
                </div>
              </div>
            ) }
            <div className="form-row">
              <div className="form-col-full">
                <div className="form-item">
                  <Form.Item
                    label="Reason"
                    name="reason"
                    rules={ [{ required: true, message: "Please enter your reason!" }] }
                  >
                    <TextArea maxLength={ 100 } className="textarea-fixed-height" />
                  </Form.Item>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Form>
    </Modal>
  );
};

export default AddWfhRequestModal;